export default {"src":"/_next/static/media/call-me.0661c97f.svg","height":280,"width":119,"blurWidth":0,"blurHeight":0};